import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-z3o6c0-0"
})(["display:flex;justify-content:space-between;padding:18px 24px;"]);